import { Link } from 'react-router-dom';
import * as C from './styles.js';
import Default from './default/index.js';
import Images from '../components/images/index.js';
import Others from '../components/others/index.js';
import Trailers from '../components/trailers/index.js';
import Providers from '../components/providers/index.js';
import Crew from '../components/crew/index.js';
import Seasons from '../components/seasons/index.js';

export default function Tabs( { movie_data, movie_data_db, media_type, movie_id, movie_id_imdb, tab, linkBase } ) {

    return (
        <C.Container>
            <C.Content>
                <aside>
                    {media_type == 'tv' &&
                        <Link to={`${linkBase}?detalhes=temporadas`} className={tab == 'temporadas' ? 'active' : ''}>Temporadas</Link>
                    }
                    <Link to={`${linkBase}?detalhes=onde-assistir`} className={tab == 'onde-assistir' ? 'active' : ''}>Onde Assistir</Link>
                    <Link to={`${linkBase}?detalhes=imagens`} className={tab == 'imagens' ? 'active' : ''}>Imagens</Link>
                    <Link to={`${linkBase}?detalhes=trailers`} className={tab == 'trailers' ? 'active' : ''}>Trailers</Link>
                    <Link to={`${linkBase}?detalhes=producao`} className={tab == 'producao' ? 'active' : ''}>Produção</Link>
                    <Link to={`${linkBase}?detalhes=outras-informacoes`} className={tab == 'outras-informacoes' ? 'active' : ''}>Outros</Link>
                </aside>
                {tab == 'temporadas' && <Seasons movie={movie_data} media_type={media_type} movie_id={movie_id}/>}
                {tab == 'onde-assistir' && <Providers media_type={media_type} movie_id={movie_id} movie_name={movie_data?.name || movie_data?.title}/>}
                {tab == 'trailers' && <Trailers media_type={media_type} movie_id={movie_id}/>}
                {tab == 'imagens' && <Images media_type={media_type} movie_id={movie_id}/>}
                {tab == 'producao' && <Crew media_type={media_type} movie_id={movie_id}/>}
                {tab == 'outras-informacoes' && <Others movie_data={movie_data} movie_data_db={movie_data_db} media_type={media_type} movie_id={movie_id} movie_id_imdb={movie_id_imdb}/>}
                {(tab != "temporadas" && tab != "imagens" && tab != "producao" && tab != "onde-assistir" && tab != "trailers" && tab != "outras-informacoes") &&
                    <Default/>
                }
            </C.Content>
        </C.Container>
    )
}